import { wideFontSize20 } from "../utils";
import { AxisDateTimeLabelFormatsOptions, CSSObject } from "highcharts";

export const HCDateLabelsStyle: (options?: CSSObject) => CSSObject = (options: CSSObject = {}) => ({
    fontWeight: '500',
    color: "#707F8C",
    fontSize: wideFontSize20(),
    ...options
})
export const HCDateLabelsFormat: AxisDateTimeLabelFormatsOptions = {
    day: '%e %b'
}